import {Hydra} from '../generic/hydra';

import {ActivityInterface} from './Activity';
import {TaskCompletedRequest as TaskCompletedRequestBaseInterface} from '../../interface/api/TaskCompletedRequest';

export type TaskCompletedRequestInterface = TaskCompletedRequestBaseInterface;

export class TaskCompletedRequest extends Hydra implements TaskCompletedRequestInterface {

    activity: ActivityInterface | string = null;

    commentaire?: string | null;


    constructor(options: TaskCompletedRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
